/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class DebounceClick implements angular.IDirective {
        restrict = "A";
        priority = -1;



        constructor($timeout: ng.ITimeoutService) {
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, $timeout: ng.ITimeoutService) => {
            var disabled = false;

            function onClick(evt) {
                if (disabled) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                } else {
                    disabled = true;
                    window.setTimeout(function () { disabled = false; }, 500, false);
                }
            }

            scope.$on('$destroy', function () { element.off('click', onClick); });
            element.on('click', onClick);
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => {
                return new DebounceClick($timeout);
            };

            directive.$inject = ["$timeout"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("debounceClick", DebounceClick.factory());
}